import { IProperties } from 'core-components/sitebuilder/propertygenerator'

import { CommonProperties } from '../constants/commonProperties'

export const addCommonProperties = (properties: IProperties[]): IProperties[] => {
  properties?.push({
    name: CommonProperties.EventBusChannel,
    type: 'string',
    value: '',
  })

  return properties
}
